import React from 'react'
import { Link } from "react-router-dom";


const FounderMessage = () => {
    return (
        <>

            <section className="service-section-4 section-space" style={{ marginTop: "-40px" }}>
                <div className="container">
                    <div className="service-wrapper-4">
                        <div className="row g-4">
                            <div className="col-lg-6">
                                <div className="team-content-4 sticky-style">
                                    <div className="section-content-block ">
                                        <span className="section-tag wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>MD Message</span>
                                        <h2 className="section-title is-text-dark">
                                            <div style={{ position: 'relative', display: 'inline-block' }}>
                                                Smt. Anjila Attri
                                            </div>
                                        </h2>
                                        {/* <p>MD</p> */}

                                    </div>
                                    <p className="section-text wow fadeInUp" data-wow-delay=".3s" style={{ visibility: 'visible', animationDelay: '0.3s', animationName: 'fadeInUp', textAlign: "justify" }}>
                                        At our core, we believe that transportation is more than just moving goods from one place to another – it's about delivering trust, reliability, and value with every journey. Since our inception, we have focused on building a service culture that prioritizes safety, punctuality, transparency, and customer satisfaction.
                                    </p>
                                    <p className="section-text wow fadeInUp" data-wow-delay=".3s" style={{ visibility: 'visible', animationDelay: '0.3s', animationName: 'fadeInUp', textAlign: "justify" }}>
                                        Today, as the transportation industry evolves, we are committed to embracing innovation and modern technology to make logistics simpler, faster, and more efficient. Our dedicated team, robust network, and customer-first approach enable us to deliver solutions that streamline travel and supply chain challenges for both businesses and individuals.
                                    </p>
                                    <p className="section-text wow fadeInUp" data-wow-delay=".3s" style={{ visibility: 'visible', animationDelay: '0.3s', animationName: 'fadeInUp', textAlign: "justify" }}>
                                        We understand that every mile matters. That's why we continuously upgrade our fleet, train our staff, adhere to stringent safety standards, and maintain open communication with our clients. Your trust is the driving force behind our success, and we are grateful for your continued support.
                                    </p>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="service-image-4">
                                    <br />
                                    <br />
                                    <div className="service-image mt-lg-5">

                                        <img src="assets/img/Anjila Attri_1.png" alt="img" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row g-4">

                            <div className="col-lg-6">
                                <div className="service-image-4">
                                    <br />
                                    <br />
                                    <div className="service-image mt-lg-5">

                                        <img src="assets/img/Mandeep Attri_1.png" alt="img" />
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="team-content-4 sticky-style">
                                    <div className="section-content-block ">
                                        <span className="section-tag wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>Co-Founder Message</span>
                                        <h2 className="section-title is-text-dark">
                                            <div style={{ position: 'relative', display: 'inline-block' }}>
                                               Mr.  Mandeep Attri
                                            </div>
                                        </h2>
                                        <p>Co-Founder</p>

                                    </div>
                                    <p className="section-text wow fadeInUp" data-wow-delay=".3s" style={{ visibility: 'visible', animationDelay: '0.3s', animationName: 'fadeInUp', textAlign: "justify" }}>
                                       From the very beginning, our vision has been clear—to transform the way people and businesses move. Transportation is more than vehicles and routes; it is about trust, safety, time, and commitment. At Rahul Logistics, we strive every day to deliver reliable mobility solutions that make life easier for our customers and provide strong logistical support for businesses.
                                    </p>
                                    <p className="section-text wow fadeInUp" data-wow-delay=".3s" style={{ visibility: 'visible', animationDelay: '0.3s', animationName: 'fadeInUp', textAlign: "justify" }}>
                                        As Co-Founder, I firmly believe that innovation, transparency, and respect are the pillars that shape our journey. We are constantly improving our technology, expanding our fleet, and strengthening our customer service to ensure smooth, modern, and comfortable transportation experiences.
                                    </p>
                                    <p className="section-text wow fadeInUp" data-wow-delay=".3s" style={{ visibility: 'visible', animationDelay: '0.3s', animationName: 'fadeInUp', textAlign: "justify" }}>
                                       Our team works with passion and professionalism to understand every client’s need—whether it is daily staff transportation, corporate mobility, logistics movement, or special travel requirements. Your trust motivates us to go further and create a service that stands apart in safety, punctuality, and quality.

                                    </p>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>


        </>
    )
}

export default FounderMessage